export default __webpack_public_path__ + "static/media/sensla-logo-short.7389ad80.png";